import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getNotificationList,
	addNewNotification,
	addNewBulkNotification,
	updateNotification,
	deleteNotification,
	getNotification,
	readNotification,
	readBulkNotification
} from '../notification/thunk';

export const initialState = {
	itemNotificationList: [],
	itemNotificationDetail: null,
	isNotificationLoading: false,
	isNotificationSuccess: false,

	notificationList: [],
	notificationListSelect: [],
	itemOrganizationalChart: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const NotificationSlice = createSlice({
	name: 'Notifications',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getNotification.fulfilled, (state, action) => {
			state.isNotificationLoading = false;
			state.isNotificationSuccess = true;
			state.itemNotificationDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getNotification.pending, state => {
			state.isNotificationLoading = true;
			state.isNotificationSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getNotification.rejected, (state, action) => {
			state.isNotificationLoading = false;
			state.isNotificationSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getNotificationList.pending, state => {
			state.isNotificationSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getNotificationList.fulfilled, (state, action) => {
			state.itemNotificationList = action.payload;
			state.notificationList = action.payload;
			state.isLoadingList = false;
			state.isNotificationSuccess = true;

			let notificationListSelect = [];
			action.payload.map(item =>
				notificationListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.notificationListSelect = notificationListSelect;
		});
		builder.addCase(getNotificationList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isNotificationSuccess = true;
		});
		
		builder.addCase(addNewNotification.fulfilled, (state, action) => {
			state.itemNotificationList.push(action.payload);
			state.notificationList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewNotification.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewNotification.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		
		
		builder.addCase(addNewBulkNotification.fulfilled, (state, action) => {
			state.itemNotificationList.push(action.payload);
			state.notificationList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewBulkNotification.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewBulkNotification.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateNotification.fulfilled, (state, action) => {
			state.itemNotificationList = state.itemNotificationList.map(notification =>
				notification.notificationname === action.payload.old_notification
					? { ...notification, ...action.payload.updated_notification }
					: notification
			);
			state.notificationList = state.notificationList.map(notification =>
				notification._id.toString() === action.payload._id.toString()
					? { ...notification, ...action.payload }
					: notification
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateNotification.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateNotification.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteNotification.fulfilled, (state, action) => {
			state.itemNotificationList = current(state.itemNotificationList).filter(
				item => item._id !== action.payload._id
			);
			state.notificationList = current(state.notificationList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteNotification.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteNotification.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		}); 



		builder.addCase(readNotification.fulfilled, (state, action) => {
			state.itemNotificationDetail = action.payload;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(readNotification.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(readNotification.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(readBulkNotification.fulfilled, (state, action) => {
			state.itemNotificationDetail = action.payload;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(readBulkNotification.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(readBulkNotification.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});



	},
});

export const { setRequireCloseModal } = NotificationSlice.actions;

export default NotificationSlice.reducer;
